import { useEffect, useState } from 'preact/hooks'

import api from '../utils/api'
import { ratingOf } from '../utils/rating'
import {
  focusLabel,
  formatDuration,
  intensityLabel,
  typeLabel
} from '../utils/workout'

function formatDate(value) {
  if (!value)
    return '—'

  return new Date(value).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export function Reviews() {
  const [rows, setRows] = useState(undefined)
  const [error, setError] = useState(null)

  useEffect(() => {
    api
      .get('/api/reviews')
      .then((res) => setRows(res.reviews))
      .catch((e) => setError(e.code))
  }, [])

  return (
    <main class="page reviews">
      <header class="top">
        <h1>Opiniones</h1>
        <a class="button small" href="/">Volver</a>
      </header>
      {error && <p class="error">{error}</p>}
      {rows && rows.length === 0 && (
        <p class="muted">Todavía no hay opiniones.</p>
      )}
      {rows && rows.length > 0 && (
        <div class="table-scroll">
          <table>
            <thead>
              <tr>
                <th class="num">Día</th>
                <th>Ref</th>
                <th>Workout</th>
                <th>Tipo</th>
                <th>Intensidad</th>
                <th class="num">Duración</th>
                <th>Foco</th>
                <th>Empezado</th>
                <th>Completado</th>
                <th>Nota</th>
                <th>Comentario</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <ReviewRow key={row.id} row={row} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </main>
  )
}

function ReviewRow({ row }) {
  const workout = row.workout
  const rating = ratingOf(row.rating)

  return (
    <tr>
      <td class="num">{row.day}</td>
      <td class="nowrap">{workout.ref}</td>
      <td class="nowrap">{workout.title}</td>
      <td class="nowrap">{typeLabel(workout.type)}</td>
      <td>{intensityLabel(workout.intensity)}</td>
      <td class="num">{formatDuration(workout.durationS)}</td>
      <td class="nowrap">
        {workout.bodyFocus ? focusLabel(workout.bodyFocus) : '—'}
      </td>
      <td class="nowrap">{formatDate(row.startedAt)}</td>
      <td class="nowrap">{formatDate(row.completedAt)}</td>
      <td class="nowrap" title={rating?.label}>
        <span class="face">{rating?.face}</span> {row.rating}
      </td>
      <td class="comment">{row.comment || <span class="muted">—</span>}</td>
    </tr>
  )
}
